<template>
  <div>
    <t-card class="card_common" v-loading="showFlag">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col :span="8" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              ref="addBtn"
              class="button_common"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button>
          </t-col>

          <t-col :span="8" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              ref="delBtn"
              class="button_common"
              @click="deleteClickSelected()"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
              @submit.native.prevent
            >
              <t-row>
                <t-col :span="parseInt($t('widgetSize.search.spaceSpan'))"
                  >&nbsp;</t-col
                >
                <t-col
                  :span="parseInt($t('widgetSize.search.searchKeySpan'))"
                  class="col_common_searchKey"
                >
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.search.searchSpaceSpan'))"
                  class="col_common_searchKey"
                  >&nbsp;</t-col
                >
                <t-col
                  :span="parseInt($t('widgetSize.search.searchBtnSpan'))"
                  class="col_common_search"
                >
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="supplierTableData"
          :data="supplierTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="updateClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :width="column.realWidth"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>

        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="tableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>


<script>
import { ShowSupplierEditDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { DeleteSupMstInfo, SearchSupplierInfo } from "@/services/supplierInfo";
import { GetPageDataCount } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
//import { DateFormat } from "@/utils/filter";
import masterService from "@/utils/page";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      searchConditionForm: {
        searchWord: "",
      },
      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      supplierInfoData: [],
      currentRow: null,
      showFlag: true,
      tableDatalength: 0,
      maxheight: window.innerHeight - 291.5 + 35, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6

      columns: [
        // 仕入先コード
        {
          prop: "supCode",
          label: t("resource.supplierInfo.supplierCode"),
          realWidth: t("widgetSize.tableCommon.width120"),
          width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 省略字
        {
          prop: "supAbb",
          label: t("resource.supplierInfo.supplierAbb"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 仕入先名
        {
          prop: "supName",
          label: t("resource.supplierInfo.supplierName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 仕入先略称
        {
          prop: "supAbbreviation",
          label: t("resource.supplierInfo.supplierAbbreviation"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 工場
        {
          prop: "supFactoryKbnStr",
          label: t("resource.supplierInfo.supFactoryKbn"),
          realWidth: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        // アドレス
        // {
        //   prop: "supAdd",
        //   label: t("resource.supplierInfo.supplierAddress"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },

        // TEL
        {
          prop: "supTel",
          label: t("resource.supplierInfo.supplierTel"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // FAX
        // {
        //   prop: "supFax",
        //   label: t("resource.supplierInfo.supplierFAX"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },

        // 郵便番号
        {
          prop: "supZipcode",
          label: t("resource.supplierInfo.supplierZipCode"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 貨幣
        // {
        //   prop: "supCurrency",
        //   label: t("resource.supplierInfo.currency"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },

        // 連絡先
        {
          prop: "supContacts",
          label: t("resource.supplierInfo.supplierContacts"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 連絡先TEL
        {
          prop: "supContactsTel",
          label: t("resource.supplierInfo.supplierContactTel"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 連絡先Mail
        {
          prop: "supContactsMail",
          label: t("resource.supplierInfo.supplierContactMail"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 終了日
        {
          prop: "supEndDate",
          label: t("resource.supplierInfo.endDate"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
      ],
    };
  },
  computed: {
    supplierTableData: {
      get() {
        return this.supplierInfoData.slice(
          (this.pageNo - 1) * this.pageSize,
          this.pageNo * this.pageSize
        );
      },
    },
  },

  mounted() {
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    // 初期化
    init() {
      this.searchClick();
    },

    handleResize() {
      //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
      this.maxheight = window.innerHeight - 291.5 + 35;
    },

    // 点击行时，将行数据赋值给selectedRow
    selectRow(row) {
      this.selectedRow = row;
    },

    // 検索
    searchClick() {
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      SearchSupplierInfo(this.searchConditionForm.searchWord)
        .then((res) => {
          this.supplierInfoData = res;

          this.tableDatalength = this.supplierInfoData.length;

          setColumnWidth(this.columns, this.supplierTableData);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));

          this.showFlag = false;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    // 新规
    addClick() {
      ShowSupplierEditDialog(
        { isAdd: true },
        t("resource.supplierInfo.supplierCreateView"),
        (target) => {
          this.init();
        }
      );
      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    //编辑
    updateClick(row) {
      ShowSupplierEditDialog(
        { isAdd: false, rowData: row },
        t("resource.supplierInfo.supplierEditView"),
        (target) => {
          this.init();
        }
      );
    },

    //複数行データの削除
    deleteClickSelected() {
      let data = this.$refs.supplierTableData.selection;

      if (data.length >= 1) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"), {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        })
          .then(() => {
            DeleteSupMstInfo(data)
              .then(() => {
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));

                this.init();
              })
              .catch((error) => {
                if (error.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              });
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // 翻页处理
    pageChange(val) {
      this.pageNo = val;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },
    TableSort(column) {
      // 排序后返回第一页
      this.pageNo = 1;
      masterService.TableSort(this.supplierTableData, column);
    },
    // 每页数据条数
    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.supplierTableData);
    },
  },
};
</script>

<style scoped>
::v-deep .el-form-item__label {
  text-align: left;
  margin-left: 1550px;
}
